module.exports = __webpack_public_path__ + "static/media/main.2610da68.png";